export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10375.3cb49159.jpg";